export default {
  // General UI elements
  save: "保存",
  saving: "保存中",
  cancel: "取消",
  edit: "编辑",
  delete: "删除",
  profile: "个人资料",
  settings: "设置",
  logout: "退出登录",
  language: "语言",
  loading: "加载中",
  submit: "提交",
  search: "搜索...",
  back: "返回",
  next: "下一步",
  previous: "上一步",
  continue: "继续",
  done: "完成",
  error: "错误",
  success: "成功",
  warning: "警告",
  info: "信息",
  close: "关闭",
  open: "打开",
  yes: "是",
  no: "否",
  ok: "确定",
   
  // Profile specific
  memberSince: "注册时间",
  streak: "连续记录",
  xp: "经验值",
  pro: "专业版",
  free: "免费版",
  recentActivity: "最近活动",
  noSetsYet: "暂无题库 :(",
  upgradeToPro: "升级到专业版",
  shareWithAFriend: "与朋友分享",
  copy: "复制",
  copied: "已复制！",
  contactUs: "联系我们",
  termsOfService: "服务条款",
  privacyPolicy: "隐私政策",
  accountSettings: "账号设置",
  changePassword: "修改密码",
  deleteAccount: "删除账号",
  deleteAccountConfirm: "您确定要删除您的账号吗？此操作无法撤销。",
  updateProfile: "更新个人资料",
  profileUpdated: "个人资料已成功更新",
  contactTheTeam: "联系团队",
  termsAndConditions: "条款和条件",
  logOut: "退出登录",
  usernameError1: "用户名不能为空",
  usernameError2: "请输入不同的或新的用户名",
  usernameError3: "用户名不能包含空格",
  usernameError4: "用户名不能包含大写字母",
  usernameError5: "用户名不能包含特殊字符",
  usernameError6: "用户名必须在4到18个字符之间",
  usernameError7: "用户名包含不适当的内容",
  usernameError8: "此用户名已被占用",
  editUsername: "编辑用户名：",
  clickOrDragAndDrop: "点击或拖放以上传",
  confirm: "确认",
  retake: "重做",

  // BottomNav
  profile: "个人资料",
  home: "首页",
  library: "我的题库",
  saved: "已保存",
  rankings: "排行榜",

  // Feature
  backToLibrary: "返回题库",
  exploreSets: "探索题库",
  communitySets: "社区题库",
  mySets: "我的题库",
  alreadyAdded: "已添加",
  addToLibrary: "添加到题库",
  loading: "加载中...",
  loadMoreSets: "加载更多题库",
  by: "作者",
  makePublic: "设为公开",
  subscriptionRequired: "需要订阅",
  subscriptionRequiredMessage: "您一次只能在题库中拥有10个题库。升级到专业版以获得无限题库！",

  // My Library
  deleteSet: "删除题库",
  deleteSetConfirmation: "您确定要删除此题库吗？",
  yesDelete: "是的，删除",
  collections: "公开题库",
  myLibrary: "我的题库",
  outOf10Sets: "已添加10个题库中的",
  switchBackToPro: "切换回专业版",
  upgradeToPro: "升级到专业版",
  outOf10OnFree: "已添加10个题库中的免费题库",
  letMeCook: "让我来烹饪",
  selectMode: "选择模式",
  multipleChoice: "多项选择",
  flashcards: "抽认卡",
  freeResponse: "自由回答",
  proOnly: "仅限专业版",
  leaderboard: "排行榜",
  favorites: "收藏夹",
  profile: "个人资料",
  reportBugs: "报告错误",

  // Question Card
  correctMessage: "正确！做得好。",
  typeYourAnswer: "输入您的答案...",
  submitAnswer: "提交答案",
  responseCannotBeBlank: "答案不能为空",
  noAnswerAvailable: "暂无答案",
  answerGuideline: "答案指南：",
  pleaseSubmitAnswerFirst: "请先提交您的答案",
  revealAnswer: "显示答案",
  hideAnswer: "隐藏答案",
  gradingInProgress: "评分进行中...",
  grading: "评分",
  answerGuidelines: "回答指南",
  finalScore: "最终得分:",
  evaluateAnswer: "评估答案",

  // Saved
  favorites: "收藏夹",
  searchQuestions: "搜索问题...",
  noSavedQuestions: "暂无收藏的问题。",

  // Scroller
  loadingMoreQuestions: "加载更多问题",

  // New Prompt
  deleteSet: "删除题库",
  deleteSetConfirmation: "您确定要删除此题库吗？",
  yesDelete: "是的，删除",
  cancel: "取消",
  setLimitReached: "题库数量已达到上限",
  setLimitError: "您只能在题库中同时拥有10个题库。升级到专业版以获得无限题库！",
  close: "关闭",
  uploadNotes: "上传笔记",
  general: "通用",
  title: "标题",
  setTitleMessage: "为您的AI生成的Cookr问题设置标题，以便稍后易于访问。",
  titleError1: "标题不能为空",
  titleError2: "标题包含不适当的内容",
  content: "内容",
  setContentMessage: "复制并粘贴您的笔记、讲座或任何其他文本内容。",
  contentError1: "内容不能为空",
  contentError2: "内容包含不适当的内容",
  subject: "主题",
  setSubjectMessage: "此内容的主题或主题是什么？",
  subjectError1: "主题不能为空",
  subjectError2: "主题包含不适当的内容",

  // Payment Confirmation
  returnToProfile: "返回个人资料",

  // Plans
  confirmSwitch: "确认切换到免费计划",
  confirmSwitchMessage: "您确定要切换到免费计划吗？您将失去对高级功能的访问权限。",
  buttonConfirm: "确认切换",
  processing: "处理中...",
  unlimitedScrolling: "无限滚动",
  unlimitedSubjects: "无限主题",
  aiTutorBot: "AI 教学机器人",
  newFeatureAccess: "新功能访问权限",
  saveScrolls: "保存 Scrolls",
  infiniteNoteUploads: "无限笔记上传",
  answerExplanations: "答案解释",
  shareScrolls: "分享 Scrolls",
  everythingInStandard: "标准版包含所有内容",
  current: "当前",
  switchOver: "切换到",
  forever: "/永远",
  monthly: "/每月",
  yearly: "/每年",

  // Leaderboard
  leaderboard: "排行榜",

  // Home.js
  pickASubject: "选择一个主题以开始您的会话",

  // scrollerLoader
  generatingContent: "生成内容中...",

  // Dropdown
  choose: "选择",

  titleTooLong: "标题不能超过100个字符",
}


